import { Injectable } from '@angular/core';
import {HttpService} from './http.service';
import {Observable, throwError} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {Api} from '../enum/Api';
import { Register } from '../model/register';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DisconnectdSaleService {

  constructor(
    private httpService: HttpService,
    private sessionStorageService: SessionStorageService
  ) { }

  public registerUser(registerData: Register): Observable<any> {
    return this.httpService.post('eCommercePME/eCommerceAPI/serasaCustomerCreation', Api.One_Portal, registerData).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public setProductData(data: any){
    this.sessionStorageService.setCustomData('disconnectedSaleProduct', data);
  }
    public getFullUserData(email: string): Observable<any> {
    return this.httpService.post('integration/digitalCommerce/getFullUserDataByExternalBase', Api.One_Portal, { "email": email}).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getEnterpriseDataByCNPJ(cnpj: string): Observable<any> {
    return this.httpService.post('integration/digitalCommerce/getEnterpriseDataByCNPJ', Api.One_Portal, { "cnpj": cnpj}).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );
  }

}
